module.exports = __webpack_public_path__ + "media/images/normas-ba_icon_512-50a65daa023c4ac2a6f6d72184835a7a.png";